<template>
  <div>
    <h1>Nova de Tipo de Concedente</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("tipos_concedentes", ["tipo_concedente"]),
  },
  methods: {
    ...mapActions("tipos_concedentes", ["ActionNewTipoConcedente"]),
    loadData(id) {
      this.$router.push({ name: "tipos_concedentes_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewTipoConcedente();
  },
};
</script>

<style></style>
